import React from "react";
import ResetPasswordLayout from "../../component/appLayouts/resetPassword";
import ResetPasswordForm from "../../component/resetPwdForm";


function ForgotPassword() {
  return (
    <div id="ForgotPassword-page" className="ForgotPassword-page">
      <ResetPasswordLayout>
        <ResetPasswordForm />
      </ResetPasswordLayout>
    </div>
  );
}

export default ForgotPassword;
